"use client";

import React, { createContext, useContext } from "react";
import type { ComposeEmailFormatContextValue } from "@/lib/core/crm/types";

const ComposeEmailFormatContext = createContext<ComposeEmailFormatContextValue | null>(null);

interface ComposeEmailFormatProviderProps {
  children: React.ReactNode;
  value: ComposeEmailFormatContextValue;
}

export function ComposeEmailFormatProvider({
  children,
  value,
}: ComposeEmailFormatProviderProps) {
  return (
    <ComposeEmailFormatContext.Provider value={value}>
      {children}
    </ComposeEmailFormatContext.Provider>
  );
}

export function useComposeEmailFormatContext() {
  const context = useContext(ComposeEmailFormatContext);
  if (!context) {
    throw new Error("useComposeEmailFormatContext must be used within a ComposeEmailFormatProvider");
  }
  return context;
}
